exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-container[data-v-1ad7d18d] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n}\n.table-container .pagination-item[data-v-1ad7d18d] {\n  margin-top: 20px;\n}\n.delete[data-v-1ad7d18d] {\n  color: #e47470;\n  margin-left: 10px;\n}", ""]);

// exports
